import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <>
      <section className="section pricing__v2 cu_mtpd" id="pricing">
        <div className="container">
          <div className="row mb-5">
            <div className="col-md-5 mx-auto text-center">
              <span
                className="subtitle text-uppercase mb-3"
                data-aos="fade-up"
                data-aos-delay={0}
              >
                Policies
              </span>
              <h2 className="mb-3 text-[32px]" data-aos="fade-up" data-aos-delay={100}>
                Privacy Policy
              </h2>
              <p data-aos="fade-up" data-aos-delay={200}>
                Strong Privacy Measures to Keep Your Data Safe and Confidential
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 mb-4 mb-md-0" data-aos="fade-up" data-aos-delay={300}>
              <ul>
                <li>
                  1. Data Fiduciary Statement (DPDP Act 2023) Veda Healthcure respects your privacy and acts as a Data Fiduciary for your health information.
                </li>
                <li>
                  2. Information We Collect We collect Personal Information (name, email), Usage Data, and Device Information to provide our Service.
                </li>
                <li>
                  3. How We Use Your Information To operate the Service, process transactions, personalized experiences, and comply with legal requirements.
                </li>
                <li>
                  4. Disclosure & Retention Information is shared with third-party providers strictly for fulfilment. We retain data for the account duration or legal audit purposes.
                </li>
                <li>
                  5. Your Rights & Security You may access and update data through settings. While we take reasonable steps for security, no transmission is 100% secure.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>

  );
};

export default PrivacyPolicy;
